<template>
  <section :data-theme="theme"  v-intersection-observer="onIntersectionObserver">
    <div
      class="
        flex
        w-full
        justify-center
        items-center
        min-h-screen
        bg-base-100
        p-4
      "
     
    >
      <div class="mt-12 sm:mt-0" :class="projects ? 'w-full' : ''">
        <Card />
      </div>
    </div>
  </section>
</template>

<script setup>
import Card from "@/components/Card.vue";

import { useStore } from "vuex";
import { computed, ref } from "vue";

import { vIntersectionObserver } from "@vueuse/components";

const isVisible = ref(false);

function onIntersectionObserver([{ isIntersecting }]) {
  if (isIntersecting) {
    store.dispatch("setTheme", theme.value);
  }
  isVisible.value = isIntersecting;
}

const theme = ref("synthwave");
const store = useStore();

const projects = computed(() => store.getters.getAllProjects);

</script>

<style>
</style>